(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coming-soon-film"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('launch-film')) customElements.define('launch-film', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.background = this.querySelector('.launch-film__background');
      if (this.background?.hasAttribute('data-frame-rings')) {
        const scheduleFraming = () => {
          cancelAnimationFrame(this.framingFrame);
          this.framingFrame = requestAnimationFrame(() => this.frameBackground());
        };
        this.resizeObserver = new ResizeObserver(scheduleFraming);
        for (const element of [this, ...this.querySelectorAll('.launch-film__tile, .launch-film__header, .launch-film__signup')]) this.resizeObserver.observe(element);
        window.addEventListener('resize', scheduleFraming, { signal });
        this.frameBackground();
      }
      this.video = this.querySelector('video');
      this.playback = this.querySelector('.launch-film__playback');
      this.menu = this.querySelector('details');
      if (!this.video) return;
      this.userPaused ??= false;
      this.video.muted = true;
      this.video.controls = false;
      this.video.autoplay = true;
      this.video.loop = true;
      const syncPlayback = () => {
        this.playback.setAttribute('aria-label', this.video.paused ? this.playback.dataset.playLabel : this.playback.dataset.pauseLabel);
      };
      const start = async () => {
        if (this.userPaused || !this.isConnected) return;
        try { await this.video.play(); } catch { /* Browser autoplay policies may require a gesture. */ }
        syncPlayback();
      };
      this.video.addEventListener('play', syncPlayback, { signal });
      this.video.addEventListener('pause', syncPlayback, { signal });
      this.playback.addEventListener('click', () => {
        this.userPaused = !this.video.paused;
        if (this.userPaused) this.video.pause();
        else start();
        syncPlayback();
      }, { signal });
      this.playback.hidden = false;
      syncPlayback();
      document.addEventListener('visibilitychange', () => { if (!document.hidden) start(); }, { signal });
      window.addEventListener('pageshow', start, { signal });
      this.addEventListener('keydown', (event) => { if (event.key === 'Escape') this.menu.open = false; }, { signal });
      for (const button of this.querySelectorAll('[data-preview-trigger], [data-booking-trigger]')) {
        button.addEventListener('click', () => {
          const selector = button.hasAttribute('data-preview-trigger') ? '[data-preview-dialog]' : '[data-booking-dialog]';
          const dialog = document.querySelector(selector);
          if (!dialog) return;
          dialog.showModal();
          dialog.querySelector('input:not([type="hidden"]), textarea')?.focus();
        }, { signal });
      }
      document.addEventListener('click', (event) => { if (!this.menu.contains(event.target)) this.menu.open = false; }, { signal });
      for (const button of this.menu.querySelectorAll('button')) button.addEventListener('click', () => { this.menu.open = false; }, { signal });
      start();
    }
    frameBackground() {
      const bounds = this.getBoundingClientRect();
      if (!bounds.width || !bounds.height) return;
      const tile = this.querySelector('.launch-film__tile').getBoundingClientRect();
      const width = bounds.width;
      const height = bounds.height;
      const gap = Math.min(8, width * .01);
      const screen = { left: gap, top: gap, right: width - gap, bottom: Math.min(height, window.innerHeight) - gap };
      const film = { left: tile.left - bounds.left - gap, top: tile.top - bounds.top - gap, right: tile.right - bounds.left + gap, bottom: tile.bottom - bounds.top + gap };
      const obstruction = { left: Math.max(screen.left, film.left), top: Math.max(screen.top, film.top), right: Math.min(screen.right, film.right), bottom: Math.min(screen.bottom, film.bottom) };
      const intersectionArea = (a, b) => Math.max(0, Math.min(a.right, b.right) - Math.max(a.left, b.left)) * Math.max(0, Math.min(a.bottom, b.bottom) - Math.max(a.top, b.top));
      // Normalized bounds of the three rings in coming-soon-hands.jpg only.
      // Replacement photographs use the merchant's manual crop controls.
      const rings = [[.337, .375, .456, .415], [.786, .49, .9, .563], [.543, .618, .634, .696]];
      const aspect = 2048 / 3091;
      const coverWidth = Math.max(width, height * aspect);
      let best;
      for (let zoom = 0; zoom <= 60; zoom++) {
        const imageWidth = coverWidth * (1 + zoom / 100);
        const imageHeight = imageWidth / aspect;
        const regions = rings.map(([left, top, right, bottom]) => ({ left: left * imageWidth, top: top * imageHeight, right: right * imageWidth, bottom: bottom * imageHeight }));
        const xs = [(width - imageWidth) / 2];
        const ys = [(height - imageHeight) / 2];
        for (const ring of regions) {
          xs.push(screen.left - ring.left, screen.right - ring.right, film.left - ring.right, film.right - ring.left);
          ys.push(screen.top - ring.top, screen.bottom - ring.bottom, film.top - ring.bottom, film.bottom - ring.top);
        }
        // Clamp every candidate to cover: even an impossible ring layout has no blank edges.
        const offsetsX = new Set(xs.map(x => Math.max(width - imageWidth, Math.min(0, x))));
        const offsetsY = new Set(ys.map(y => Math.max(height - imageHeight, Math.min(0, y))));
        for (const x of offsetsX) for (const y of offsetsY) {
          const visible = regions.map(ring => {
            const placed = { left: ring.left + x, top: ring.top + y, right: ring.right + x, bottom: ring.bottom + y };
            return Math.max(0, (intersectionArea(placed, screen) - intersectionArea(placed, obstruction)) / ((ring.right - ring.left) * (ring.bottom - ring.top)));
          });
          // Prioritize visible rings, then the smallest zoom and most centered crop.
          const loss = visible.reduce((total, fraction) => total + 1 - fraction, 0);
          const displacement = Math.abs(x - (width - imageWidth) / 2) / imageWidth + Math.abs(y - (height - imageHeight) / 2) / imageHeight;
          const score = loss * 1000 + (1 - Math.min(...visible)) * 100 + zoom * .1 + displacement * .01;
          if (!best || score < best.score) best = { x, y, imageWidth, imageHeight, score };
        }
      }
      this.background.style.setProperty('--lf-framed-x', `${best.x}px`);
      this.background.style.setProperty('--lf-framed-y', `${best.y}px`);
      this.background.style.setProperty('--lf-framed-width', `${best.imageWidth}px`);
      this.background.style.setProperty('--lf-framed-height', `${best.imageHeight}px`);
      this.background.setAttribute('data-framed', '');
    }
    disconnectedCallback() { this.controller?.abort(); this.resizeObserver?.disconnect(); cancelAnimationFrame(this.framingFrame); this.video?.pause(); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coming-soon-hero"] && !Shopify.designMode) return;
  try {
    
  class CarouselFrame extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('.coming-soon__stage');
      if (!this.stage) return;
      this.slides = Array.from(this.stage.querySelectorAll('.coming-soon__slide'));
      if (this.slides.length < 2) return;

      this.status = this.querySelector('.coming-soon__status');
      this.statusTemplate = this.dataset.statusTemplate || '';
      this.hero = this.closest('.coming-soon') || this;
      this.index = Math.max(
        0,
        this.slides.findIndex((slide) => slide.classList.contains('is-active'))
      );
      this.wheelTotal = 0;
      this.lastStep = 0;
      this.touchY = null;
      this.interacted = false;

      this.onWheel = this.handleWheel.bind(this);
      this.onTouchStart = this.handleTouchStart.bind(this);
      this.onTouchEnd = this.handleTouchEnd.bind(this);
      this.onKeydown = this.handleKeydown.bind(this);
      this.onBlockSelect = this.handleBlockSelect.bind(this);

      this.hero.addEventListener('wheel', this.onWheel, { passive: false });
      this.hero.addEventListener('touchstart', this.onTouchStart, { passive: true });
      this.hero.addEventListener('touchend', this.onTouchEnd, { passive: true });
      this.stage.addEventListener('keydown', this.onKeydown);
      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      this.interval = Number(this.dataset.autoplay);
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Idle hint: appears after a quiet moment, leaves once the visitor
      // starts moving through the gallery.
      this.hint = this.hero.querySelector('[data-scroll-hint]');
      if (this.hint) {
        this.hintTimer = setTimeout(() => {
          if (!this.interacted) this.hint.classList.add('is-visible');
        }, 3000);
      }

      this.startAutoplay();
    }

    startAutoplay() {
      if (!this.interval || this.reduced || this.interacted) return;
      clearInterval(this.timer);
      this.timer = setInterval(() => this.goTo(this.index + 1, false), this.interval * 1000);
    }

    dismissHint() {
      if (!this.hint) return;
      clearTimeout(this.hintTimer);
      this.hint.classList.remove('is-visible');
      this.hint.classList.add('is-dismissed');
      this.hint = null;
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      clearTimeout(this.hintTimer);
      if (this.hero) {
        this.hero.removeEventListener('wheel', this.onWheel);
        this.hero.removeEventListener('touchstart', this.onTouchStart);
        this.hero.removeEventListener('touchend', this.onTouchEnd);
        this.hero.removeEventListener('pointerdown', this.onPointerDown);
      }
      if (this.stage) this.stage.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    markInteracted() {
      if (this.interacted) return;
      this.interacted = true;
      clearInterval(this.timer);
      this.dismissHint();
    }

    pageScrolls() {
      return document.documentElement.scrollHeight > window.innerHeight + 4;
    }

    goTo(next, announce) {
      const count = this.slides.length;
      this.index = ((next % count) + count) % count;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      // Autoplay rotations stay silent; only user-driven changes are
      // announced, so screen readers aren't spammed every few seconds.
      if (announce !== false && this.status && this.statusTemplate) {
        this.status.textContent = this.statusTemplate
          .replace('[[current]]', String(this.index + 1))
          .replace('[[total]]', String(count));
      }
    }

    step(direction) {
      const now = Date.now();
      if (now - this.lastStep < 700) return;
      this.lastStep = now;
      this.goTo(this.index + direction);
    }

    handleWheel(event) {
      // Only hijack the wheel when the page itself has nothing to
      // scroll; on small viewports normal scrolling wins. Ctrl+wheel is
      // pinch zoom — never intercept it.
      if (event.ctrlKey) return;
      if (this.pageScrolls()) return;
      event.preventDefault();
      this.markInteracted();
      if (Date.now() - this.lastStep < 700) {
        this.wheelTotal = 0;
        return;
      }
      this.wheelTotal += event.deltaY;
      if (Math.abs(this.wheelTotal) < 120) return;
      const direction = this.wheelTotal > 0 ? 1 : -1;
      this.wheelTotal = 0;
      this.step(direction);
    }

    handleTouchStart(event) {
      // Don't kill autoplay yet — this may just be a page scroll passing
      // over the hero. Interaction is decided in handleTouchEnd.
      this.touchY = event.touches[0].clientY;
      this.touchOnStage = this.stage.contains(event.target);
    }

    handleTouchEnd(event) {
      if (this.touchY === null) return;
      const delta = this.touchY - event.changedTouches[0].clientY;
      this.touchY = null;
      if (Math.abs(delta) < 40) return;
      // When the page scrolls normally, only swipes that begin on the
      // framed stage navigate slides; elsewhere the scroll wins.
      if (this.pageScrolls() && !this.touchOnStage) return;
      this.markInteracted();
      this.step(delta > 0 ? 1 : -1);
    }

    handleKeydown(event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      this.markInteracted();
      const direction = event.key === 'ArrowRight' ? 1 : -1;
      this.goTo(this.index + direction);
    }

    handleBlockSelect(event) {
      const i = this.slides.indexOf(event.target);
      if (i === -1) return;
      this.markInteracted();
      this.goTo(i);
    }
  }

  if (!customElements.get('carousel-frame')) {
    customElements.define('carousel-frame', CarouselFrame);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-design-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const product = new URLSearchParams(window.location.search).get('product');
    if (!product) return;

    document.querySelectorAll('[data-cd-product-input]').forEach((input) => {
      input.value = product;
    });

    document.querySelectorAll('[data-cd-regarding]').forEach((line) => {
      const name = line.querySelector('[data-cd-product-name]');
      if (name) name.textContent = product;
      line.hidden = false;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // The mobile drawer locks page scroll while open (critical.css keys on
  // details[scroll-lock][open]); close it when the viewport grows past
  // the breakpoint, on Escape, or on a tap outside the drawer.
  (() => {
    const drawer = document.querySelector('.site-header__drawer');
    if (!drawer) return;

    const desktop = window.matchMedia('(min-width: 56rem)');
    const closeOnDesktop = (mq) => {
      if (mq.matches) drawer.removeAttribute('open');
    };
    desktop.addEventListener('change', closeOnDesktop);
    closeOnDesktop(desktop);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.open) {
        drawer.removeAttribute('open');
        const summary = drawer.querySelector('summary');
        if (summary) summary.focus();
      }
    });

    document.addEventListener('click', (event) => {
      if (drawer.open && !drawer.contains(event.target)) {
        drawer.removeAttribute('open');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-footer"]) return;
  try {
    
  (() => {
    const wire = (triggerSel, dialogSel, reopenSel) => {
      const dialog = document.querySelector(dialogSel);
      const triggers = document.querySelectorAll(triggerSel);
      if (!dialog || !triggers.length) return;

      for (const trigger of triggers) trigger.addEventListener('click', () => {
        dialog.showModal();
        const input = dialog.querySelector('input:not([type="hidden"]), textarea');
        if (input) input.focus();
      });

      dialog.querySelectorAll('[data-dialog-close]').forEach((close) => {
        close.addEventListener('click', () => dialog.close());
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      // Failed or successful submissions re-render the page; reopen the
      // dialog so its errors or confirmation are seen in place.
      if (dialog.querySelector(reopenSel)) dialog.showModal();
    };

    wire('[data-booking-trigger]', '[data-booking-dialog]', '[data-booking-reopen]');
    wire('[data-preview-trigger]', '[data-preview-dialog]', '[data-preview-reopen]');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductFormRL extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector('[data-variant-data]');
      if (!dataEl) return;
      try {
        this.variants = JSON.parse(dataEl.textContent);
      } catch (error) {
        this.variants = [];
      }

      this.groups = Array.from(this.querySelectorAll('[data-option-group]'));
      this.idInput = this.querySelector('[data-variant-id]');
      // The price line renders above this element, so search the whole
      // product section for it rather than only our own subtree.
      this.section = this.closest('.product-main') || document;
      this.priceEl = this.querySelector('[data-price]') || this.section.querySelector('[data-price]');
      this.leadEl = this.querySelector('[data-lead-time]');
      this.rushEl = this.querySelector('[data-rush]');
      this.rushCheckbox = this.querySelector('[data-rush-checkbox]');
      this.productionInput = this.querySelector('[data-production]');
      this.addButton = this.querySelector('[data-add-button]');
      this.qtyInput = this.querySelector('[data-qty]');
      this.errorEl = this.querySelector('[data-form-error]');
      this.form = this.querySelector('form[data-product-form]');
      this.carePanel = this.querySelector('[data-care-panel]');
      this.careSource = this.querySelector('[data-care-source]');
      // Trust the server-rendered lead state so products without option
      // pills (single-variant) still carry the right production property.
      this.state = this.dataset.leadState || 'stock';

      this.groups.forEach((group) => {
        group.addEventListener('change', () => {
          this.reflectChoices();
          this.update(true);
        });
      });
      if (this.rushCheckbox) {
        this.rushCheckbox.addEventListener('change', () => this.syncProduction());
      }
      if (this.form) {
        this.form.addEventListener('submit', (event) => this.onSubmit(event));
      }
      if (this.groups.length) {
        this.reflectChoices();
        this.update(false);
      }
      this.syncProduction();

      // Thumbnails swap the main stage image in place.
      this.section.querySelectorAll('[data-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const stage = this.section.querySelector('.product-main__image');
          if (!stage || !thumb.dataset.full) return;
          stage.removeAttribute('srcset');
          stage.removeAttribute('sizes');
          stage.src = thumb.dataset.full;
        });
      });
    }

    chosenValues() {
      return this.groups.map((group) => {
        const checked = group.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : '';
      });
    }

    variantFor(values) {
      return this.variants.find((variant) => {
        if (!variant.options || variant.options.length !== values.length) return false;
        return variant.options.every((option, index) => option === values[index]);
      });
    }

    selectedVariant() {
      return this.variantFor(this.chosenValues());
    }

    // Echo the choice beside each option name, grey out combinations
    // that are gone or never offered, and swap the metal care note.
    reflectChoices() {
      const chosen = this.chosenValues();

      this.groups.forEach((group, groupIndex) => {
        const current = group.querySelector('[data-option-current]');
        if (current) current.textContent = chosen[groupIndex] || '';

        group.querySelectorAll('.opt-pill').forEach((pill) => {
          const input = pill.querySelector('input[type="radio"]');
          if (!input) return;
          const candidate = chosen.slice();
          candidate[groupIndex] = input.value;
          const variant = this.variantFor(candidate);
          let state = 'ok';
          if (!variant) state = 'none';
          else if (!variant.available) state = 'soldout';
          pill.dataset.state = state;
        });
      });

      this.updateCare(chosen);
    }

    updateCare(chosen) {
      if (!this.carePanel || !this.careSource) return;
      const metalIndex = this.groups.indexOf(this.careSource);
      const metal = (chosen[metalIndex] || '').toLowerCase();
      const notes = Array.from(this.carePanel.querySelectorAll('[data-care-note]'));
      let active = notes.find((note) => note.dataset.careMatch && metal.indexOf(note.dataset.careMatch) !== -1);
      if (!active) active = notes.find((note) => !note.dataset.careMatch);
      notes.forEach((note) => {
        note.hidden = note !== active;
      });
    }

    update(replaceUrl) {
      this.hideError();
      const variant = this.selectedVariant();

      if (!variant) {
        this.state = 'none';
        if (this.priceEl) this.priceEl.textContent = '—';
        if (this.idInput) this.idInput.value = '';
        this.setLead(this.dataset.textUnavailable);
        this.setBuyable(false, this.dataset.textUnavailable);
        this.toggleRush(false);
        this.syncProduction();
        return;
      }

      if (this.idInput) this.idInput.value = variant.id;

      if (replaceUrl && this.dataset.url && window.history && window.history.replaceState) {
        const url = new URL(this.dataset.url, window.location.origin);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.pathname + url.search);
      }

      if (this.dataset.bespoke === 'true') return;

      if (this.priceEl) this.priceEl.textContent = variant.priceFormatted;

      if (variant.inventoryQuantity > 0 || (!variant.inventoryTracked && variant.available)) {
        this.state = 'stock';
        this.setLead(this.dataset.textInStock);
        this.setBuyable(true, this.dataset.textAdd);
        this.toggleRush(false);
      } else if (variant.available) {
        this.state = 'mto';
        this.setLead(this.dataset.textMadeToOrder);
        this.setBuyable(true, this.dataset.textAdd);
        this.toggleRush(true);
      } else {
        this.state = 'soldout';
        this.setLead(this.dataset.textSoldOut);
        this.setBuyable(false, this.dataset.textSoldOut);
        this.toggleRush(false);
      }

      this.syncProduction();
    }

    setLead(text) {
      if (this.leadEl && text) this.leadEl.textContent = text;
    }

    setBuyable(enabled, label) {
      if (!this.addButton) return;
      this.addButton.disabled = !enabled;
      if (label) this.addButton.textContent = label;
    }

    toggleRush(show) {
      if (!this.rushEl) return;
      this.rushEl.hidden = !show;
      if (!show && this.rushCheckbox) this.rushCheckbox.checked = false;
    }

    syncProduction() {
      if (!this.productionInput) return;
      if (this.state === 'mto') {
        this.productionInput.disabled = false;
        if (this.rushCheckbox && this.rushCheckbox.checked) {
          this.productionInput.value = this.dataset.productionRush;
        } else {
          this.productionInput.value = this.dataset.productionMto;
        }
      } else {
        this.productionInput.disabled = true;
      }
    }

    onSubmit(event) {
      const rushWanted = this.rushCheckbox && this.rushCheckbox.checked && this.rushEl && !this.rushEl.hidden;
      if (!rushWanted || !this.dataset.rushVariant || !this.idInput) return;

      event.preventDefault();
      this.hideError();

      const quantity = this.qtyInput ? parseInt(this.qtyInput.value, 10) || 1 : 1;
      const properties = {};
      properties[this.dataset.propertyName] = this.dataset.productionRush;

      const items = [
        { id: Number(this.idInput.value), quantity: quantity, properties: properties },
        { id: Number(this.dataset.rushVariant), quantity: 1 }
      ];

      if (this.addButton) this.addButton.disabled = true;

      fetch(this.dataset.cartAddUrl || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then((response) => {
          if (!response.ok) throw new Error('cart-add-failed');
          window.location.href = this.dataset.cartUrl || '/cart';
        })
        .catch(() => {
          // The multi-item add is atomic, so a refused rush fee blocks the
          // whole order — tell the customer exactly how to proceed.
          if (this.addButton) this.addButton.disabled = false;
          this.showError(this.dataset.textRushError || this.dataset.textError);
        });
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message || this.dataset.textError;
      this.errorEl.hidden = false;
    }

    hideError() {
      if (this.errorEl) this.errorEl.hidden = true;
    }
  }

  if (!customElements.get('product-form-rl')) {
    customElements.define('product-form-rl', ProductFormRL);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-slideshow"] && !Shopify.designMode) return;
  try {
    
  class StorySlideshow extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('.story-slides__stage');
      this.slides = Array.from(this.querySelectorAll('.story-slides__slide'));
      if (this.slides.length < 2) return;
      this.dots = Array.from(this.querySelectorAll('[data-slide-dot]'));
      this.status = this.querySelector('.story-slides__status');
      this.statusTemplate = this.dataset.statusTemplate || '';
      this.index = 0;
      this.touchX = null;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const prev = this.querySelector('[data-slide-prev]');
      const next = this.querySelector('[data-slide-next]');
      if (prev) prev.addEventListener('click', () => this.step(-1, true));
      if (next) next.addEventListener('click', () => this.step(1, true));
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(Number(dot.dataset.slideDot), true));
      });

      this.stage.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.step(event.key === 'ArrowRight' ? 1 : -1, true);
      });

      this.addEventListener('touchstart', (event) => {
        this.touchX = event.touches[0].clientX;
      }, { passive: true });
      this.addEventListener('touchend', (event) => {
        if (this.touchX === null) return;
        const delta = this.touchX - event.changedTouches[0].clientX;
        this.touchX = null;
        if (Math.abs(delta) < 40) return;
        this.step(delta > 0 ? 1 : -1, true);
      }, { passive: true });

      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:block:select', (event) => {
          const i = this.slides.indexOf(event.target);
          if (i !== -1) this.goTo(i, true);
        });
      }

      const interval = Number(this.dataset.autoplay);
      if (interval && !this.reduced) {
        this.timer = setInterval(() => this.goTo(this.index + 1, false), interval * 1000);
      }
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    step(direction, byUser) {
      this.goTo(this.index + direction, byUser);
    }

    goTo(next, byUser) {
      if (byUser) clearInterval(this.timer);
      const count = this.slides.length;
      const target = ((next % count) + count) % count;
      if (target === this.index) return;
      const leaving = this.slides[this.index];
      this.index = target;
      this.slides.forEach((slide, i) => {
        slide.classList.remove('is-leaving');
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      if (this.dataset.transition === 'slide' && leaving) {
        leaving.classList.add('is-leaving');
      }
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
      if (byUser && this.status && this.statusTemplate) {
        this.status.textContent = this.statusTemplate
          .replace('[[current]]', String(this.index + 1))
          .replace('[[total]]', String(count));
      }
    }
  }

  if (!customElements.get('story-slideshow')) {
    customElements.define('story-slideshow', StorySlideshow);
  }

  } catch(e) { console.error(e); }
})();
})();
